/**
 * Derives a shared Sentry trace_id from a video_render_id so a render's exceptions
 * across the web worker, node_render_worker, and this nwjs renderer all land in one
 * Sentry trace. Reimplemented identically in the web repo (libs/render_trace.py) and
 * node_render_worker/render_trace.py; golden-value tests lock the three in sync.
 */
export function renderTraceId(videoRenderId: string | number): string {
    // Sentry requires a 32-char hex trace_id; zero-pad the id's hex form.
    return BigInt(videoRenderId).toString(16).padStart(32, '0');
}
